export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">移动观影</span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">随时随地 · 畅享精彩</h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              91电影视频移动版现已支持手机和平板设备，无论你在地铁上、旅途中还是睡前时光，
              打开浏览器即可流畅观看高清影视内容，享受与桌面端一致的高品质观影体验。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-6 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                <span className="w-7 h-7 flex items-center justify-center text-foreground-800"><i className="ri-android-line text-xl"></i></span>
                <div className="text-left">
                  <div className="text-[10px] text-foreground-500 leading-none whitespace-nowrap">下载 Android 版</div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">安卓客户端</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                <span className="w-7 h-7 flex items-center justify-center text-foreground-800"><i className="ri-apple-line text-xl"></i></span>
                <div className="text-left">
                  <div className="text-[10px] text-foreground-500 leading-none whitespace-nowrap">下载 iOS 版</div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">苹果客户端</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xs lg:max-w-sm">
            <div className="relative rounded-3xl overflow-hidden bg-background-50 p-3 shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20modern%20movie%20streaming%20app%20interface%20with%20movie%20posters%20grid%20layout%2C%20dark%20theme%20UI%20design%2C%20clean%20minimalist%20app%20screenshot%2C%20colorful%20film%20thumbnails%2C%20professional%20mobile%20app%20design&width=400&height=700&seq=app-mockup-01&orientation=portrait"
                alt="91电影视频移动端界面预览"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}